module.exports = __webpack_public_path__ + "img/juragan-material-logo.a0e33c33.png";